import { Controller } from "@hotwired/stimulus"

// Focuses its element as soon as it arrives. The HTML autofocus attribute only
// fires on a page load or a frame navigation, so an element rendered into a
// lazily loaded turbo-frame — the sample controls, which wait for their card to
// be scrolled into view — would never receive it.
export default class extends Controller {
  connect() {
    this.element.focus()
  }
}
